import React, { useCallback } from 'react';
import Button from '@atlaskit/button/new';
import FeedbackIcon from '@atlaskit/icon/glyph/feedback';
import { useFeedbackCollector } from '@atlassian/jira-business-feedback-collector/src/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const FEEDBACK_GROUP_ID = 'list-view-issue-field-statistics-feedback';

export const FeedbackButton = () => {
	const { formatMessage } = useIntl();
	const openFeedbackModal = useFeedbackCollector();
	const onClick = useCallback(() => {
		openFeedbackModal(FEEDBACK_GROUP_ID);
	}, [openFeedbackModal]);

	return (
		<Button spacing="default" iconBefore={FeedbackIcon} onClick={onClick} appearance="subtle">
			{formatMessage(messages.feedback)}
		</Button>
	);
};
